export const setToastPosition = (element: HTMLElement | null) => {
    const toastContainer = document.querySelector<HTMLElement>('#yt-toast__container');
    const width = window.innerWidth;
    const elementXPostion = element?.getBoundingClientRect().x;
    const isElementHidden = element?.style.visibility === 'hidden';

    if (toastContainer && elementXPostion !== undefined && !isElementHidden) {
        const toastRightPosition = width - elementXPostion;

        toastContainer.style.right = `${toastRightPosition}px`;
    }
};

export const resetToastPosition = () => {
    const toastContainer = document.querySelector<HTMLElement>('#yt-toast__container');

    if (toastContainer) {
        toastContainer.style.right = '0';
    }
};
